<template>
  <master-crud-page
    master="alert/rule"
    title="Alert Rule"
    access="master_alert_rule"
    pk="alruId"
    :columns="columns"
    :fields="fields"
    :filters="filters"
    :embedded="embedded"
    :allow-create="false"
    :allow-delete="false"
    page-size-selectable
    :page-size="25"
    forbidden-text="This module is internal only."
  >
    <template #intro>
      Changes apply automatically within about a minute.
    </template>
    <template #row-actions="{ row }">
      <b-button
        v-if="canEditWording(row)"
        size="sm"
        variant="outline-primary"
        class="mt-1"
        @click="editWording(row)"
      >
        Edit wording
      </b-button>
    </template>
  </master-crud-page>
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';
import {
  SEVERITY_OPTIONS, STATUS_OPTIONS, relationOf, severityVariant, statusColumn,
} from '@/util/notificationConfig';

export default {
  name: 'MasterAlertRule',
  components: { MasterCrudPage },
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      columns: [
        { key: 'alruName', label: 'Name', align: 'left' },
        { key: 'alruCode', label: 'Code', align: 'left' },
        {
          key: 'alruSeverity', label: 'Severity', type: 'badge', variant: (row) => severityVariant(row.alruSeverity),
        },
        statusColumn('alruEnabled', 'Status'),
        {
          key: 'alruTopic',
          label: 'Topic',
          align: 'left',
          formatter: (value) => {
            const topic = relationOf(value);
            return topic ? topic.ntopName : '-';
          },
        },
        {
          key: 'alruUpdatedTime',
          label: 'Updated',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'alruCode', label: 'Code', type: 'text', lockOnEdit: true, virtual: true,
        },
        {
          key: 'alruName', label: 'Name', type: 'text', required: true,
        },
        {
          key: 'alruSeverity', label: 'Severity', type: 'select', required: true, options: SEVERITY_OPTIONS,
        },
        {
          key: 'alruEnabled', label: 'Status', type: 'select', required: true, options: STATUS_OPTIONS,
        },
        {
          key: 'alruParams', label: 'Parameters', type: 'params', colMd: 12,
        },
      ],
      filters: [
        {
          key: 'alruSeverity', label: 'Severity', type: 'select', options: SEVERITY_OPTIONS, colMd: 3,
        },
        {
          key: 'alruEnabled', label: 'Status', type: 'select', options: STATUS_OPTIONS, colMd: 3,
        },
      ],
    };
  },
  methods: {
    canEditWording(row) {
      return !!relationOf(row.alruTopic) && this.canRead('master_notification_template');
    },
    editWording(row) {
      const topic = relationOf(row.alruTopic);
      this.$router.replace({ query: { tab: 'template', topic: String(topic.ntopId) } }).catch((err) => console.error(err));
    },
  },
};
</script>
